import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link2 } from 'lucide-react';
import { buildCollectResponderLink } from '../utils/collectResponderLink';

export type CopyResponderLinkButtonProps = {
    responderLinkToken?: string | null;
    className?: string;
    variant?: 'outline' | 'primary';
};

const CopyResponderLinkButton: React.FC<CopyResponderLinkButtonProps> = ({
    responderLinkToken,
    className,
    variant = 'outline',
}) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const copyLink = useCallback(async () => {
        const token = (responderLinkToken || '').trim();
        if (!token) return;
        const url = buildCollectResponderLink(token);
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 2500);
        } catch {
            /* fallback silencieux */
        }
    }, [responderLinkToken]);

    if (!(responderLinkToken || '').trim()) {
        return null;
    }

    const btnClass =
        className ??
        (variant === 'primary' ? 'btn btn-primary' : 'btn btn-outline-light btn-sm');

    return (
        <button
            type="button"
            className={`${btnClass} d-inline-flex align-items-center gap-1 text-nowrap`}
            onClick={() => void copyLink()}
        >
            <Link2 size={16} className="flex-shrink-0" aria-hidden />
            <span>
                {copied
                    ? t('form.collectWorkspace.responderLinkCopied', 'Link copied!')
                    : t('form.collectWorkspace.copyResponderLink', 'Copy responder link')}
            </span>
        </button>
    );
};

export default CopyResponderLinkButton;
